import React from 'react'
import Text from 'react-text'
import Select from 'react-select'
import {Consumer} from '../../context'
import './filters.styl'

function SelectFilter(props) {
  const {name, options, mapQuery = a => a} = props
  const className = `select-${name}`
  return (<Consumer>{ context => {
    const id = context.query[name]
    const value = options.find(prop => prop.id == id) || null
    const placeholder = context.translate(`${name}_placeholder`)
    return (
      <div className={className}>
        <div className="dropdown">
          <Select
            className={className}
            classNamePrefix="select"
            formatOptionLabel = {({name}) => name}
            isSearchable = {false}
            isClearable = {true}
            escapeClearsValue = {true}
            getOptionValue = {({id}) => id}
            placeholder = {placeholder}
            value = {value}
            onChange = {option => {
              const {id} = option || {}
              const query = mapQuery({[name]: id})
              context.navigate({}, context.match.path, {preserveQuery: true, query})
            }}
            options = {options}
          />
        </div>
      </div>
    )
  }}</Consumer>)
}

export default function Filters () {
  return (<Consumer>{ context => {
    const {groups, query} = context
    const {students} = groups.find(group => group.id == query.group) || {students: []}
    return (
      <div className="filters-wrapper">
        <div className="filters">
          <SelectFilter name="group" options={groups} mapQuery={q => ({...q, student: undefined})} />
          <SelectFilter name="student" options={students} />
        </div>
      </div>
  )}}</Consumer>)
}
